<template>
    <v-tooltip bottom color="grey darken-3">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          :class="`
            work-bench-workpackage-iconpicker
            color-4
            font-weight-light
            `"
          :style="selected_icon === icon?'border: white solid 1px !important;':''"
          @click="$emit('clickIcon', icon)"
        >
          <TIcon
            :name="icon"
            color="primary"
            medium
          />
        </div>
      </template>
      <div class="work-bench-workpackage-iconpicker-tooltip">
        <TIcon
          :name="icon"
          color="white"
          giant
        />
        {{ icon }}
      </div>
    </v-tooltip>
</template>
<script>
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  export default {
    props: ['icon', 'color', 'text_color', 'selected_icon'],
    components: {
      TIcon
    },
    computed: {
    },
    data: () => ({
    }),
  }
</script>
<style>
  .work-bench-workpackage-iconpicker {
    display: flex;
    height: 30px;
    width: 45px;
    justify-content: center;
    align-items: center;
    align-content: center;
    line-height: 30px;
    border-radius: 3px;
    margin: 3px;
    border: 1px black solid !important;
    cursor: pointer;
  }
  .work-bench-workpackage-iconpicker-tooltip {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
